/* eslint-disable react/prop-types */
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import styles from './CloseButton.module.css';
import useTheme from '../../theme/theme';

function ThemeButton({
  width = '30px',
  height = '30px',
}) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      className={styles.buttonDelete}
      onClick={toggle}
      style={{
        background: 'none',
        cursor: 'pointer',
        border: 'none',
        height,
        width,
        padding: 'var(--space-xs)',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'var(--radius-circle)',
      }}
    >
      {theme === 'light' ? (
        <Sun
          className={styles.trash}
          style={{ color: 'var(--visible)' }}
          size={20}
        />
      ) : (
        <Moon
          className={styles.trash}
          style={{ color: 'var(--visible)' }}
          size={20}
        />
      )}
    </button>
  );
}
export default ThemeButton;
